export enum DimsAndWeightModal {
  COMPLETE_SESSION_MODAL = "COMPLETE_SESSION_MODAL",
}
